/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-calculator': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M448 0H64C46.368 0 32 14.368 32 32v448c0 17.664 14.368 32 32 32h384c17.664 0 32-14.336 32-32V32c0-17.632-14.336-32-32-32zM160 448H96v-64h64v64zm0-128H96v-64h64v64zm128 128h-64v-64h64v64zm0-128h-64v-64h64v64zm128 128h-64V256h64v192zm0-272c0 8.832-7.168 16-16 16H112c-8.832 0-16-7.168-16-16V80c0-8.832 7.168-16 16-16h288c8.832 0 16 7.168 16 16v96z"/>'
  }
})
